import RootModel from 'Models/Root'

export default RootModel.create({})